export default "__VITE_ASSET__CcjMKBQT__"